import { CSSProperties } from "react";

export default class DenyAvailabilityDialogViewStyle {
    date: CSSProperties = {
        fontWeight: 400
    }
}